import React from 'react';

import { Box } from '@chakra-ui/react';
import ProfileFieldCard from './ProfileFieldCard';
import { useUserProfile } from '../../../../hooks/V2/useUser';

const MonthYearGraduation = () => {
	const { data: profile } = useUserProfile();
	return (
		<Box>
			<ProfileFieldCard
				keyName="month-year-graduation"
				title={`${
					profile?.graduationYear && profile?.graduationYear >= 0 ? profile?.graduationYear : 'NA'
				}`}
				heading="Month and Year of Graduation"
			/>
		</Box>
	);
};

export default MonthYearGraduation;
